import { api } from "./axios";
import {
  TranscriptResponse,
  SequenceInputTypes,
  POfftargetInputTypes,
  POfftargetResponse,
  OutputQueryResponse,
  PrimerDesignParamTypes,
  PrimerDesignResponseTypes,
  GenomeAssembliesResponse,
  OnlyDNAResult,
} from "@src/types";

export const getTranscriptList = (
  payload: SequenceInputTypes
): Promise<TranscriptResponse> => {
  return api.post("fetch_transcript_list/", payload);
};

export const getResult = (
  payload: SequenceInputTypes
): Promise<OutputQueryResponse> => {
  const mode = sessionStorage.getItem("mode");
  const API =
    mode === "codon" ? "stop_codon_design/" : "dna_base_editor_analysis/";
  return api.post(API, payload);
};

export const getDNAResult = (
  payload: OnlyDNAResult
): Promise<OutputQueryResponse> => {
  const API = "base_editing_only/";
  return api.post(API, payload);
};

export const getPotentialOfftargetList = (
  payload: POfftargetInputTypes
): Promise<POfftargetResponse> => {
  return api.post("off_target_details/", payload);
};

export const getAutocompleteResults = (
  genome: string,
  query?: string
): Promise<any> => {
  return api.get("search/", {
    params: {
      query: query,
      genome: genome,
    },
  });
};

// Primer Design Download
export const getPrimerDesignDownload = (
  payload: PrimerDesignParamTypes
): Promise<{ data: PrimerDesignResponseTypes }> => {
  return api.post("primer_design/", payload);
};

export const getGenomeAssemblies = (): Promise<GenomeAssembliesResponse> => {
  console.log("getGenomeAssemblies called");
  return api.get("genome_assemblies/");
};
